














import Vue from 'vue'
import { camelizeKeys, kebabToCamelCase } from '@/utils'

import ItemFactory from '../../elements/likert/ItemFactory'
import Instruction from '../../elements/Instruction.vue'
import SurveyMixin from '../SurveyMixin'

const settings = kebabToCamelCase(require('./inep.yml'))
const factory = new ItemFactory(settings)

export default Vue.extend({
  mixins: [SurveyMixin],
  components: { Instruction },
  data() {
    return {
      settings,
      section1Items: factory.scanRange(1, 6),
      section2Items: factory.scanRange(7, 15),
    }
  },
})
